<ng-container *ngIf="aemContent">
  <h3 class="m-t-xl">{{ aemContent?.summary }}</h3>
  <h4 class="m-t-lg">Lines</h4>
  <p class="lead bold m-t-md" *ngIf="formattedTotalNumberOfLines">
    {{ formattedTotalNumberOfLines }}
  </p>
  <div class="row">
    <div class="col-12">
      <p *ngIf="cartHasOnlyDevice" class="m-t-sm">
        {{ aemContent?.deviceNeedsAPlan }}
      </p>
      <p *ngIf="cartHasOnlyPlan" class="m-t-sm">
        {{ aemContent?.lineNeedsADevice }}
      </p>
      <p *ngIf="needPlanAndDevice" class="m-t-sm">
        1 {{ aemContent?.lineNeedsPlanAndDeviceSelection }}
      </p>
      <p class="lead bold m-t-lg" *ngIf="hasRepPermissionForMultiLine">
        You have {{ totalLinesCount }} line(s) in cart
      </p>
    </div>
  </div>
  <div class="row m-t-xl" *ngIf="seeAll">
    <div
      [class]="idx === 0 ? 'col-12' : 'col-12 m-t-xl'"
      *ngFor="let line of lineSummaryModels; let idx = index"
    >
      <p class="lead bold" *ngIf="line.lineName">{{ line.nickName }}</p>
      <p class="lead bold" *ngIf="!line.lineName">
        {{ aemContent?.line }} {{ line?.currentLineNumber }}
      </p>
      <p *ngIf="!line?.byodCMMOrImei?.imei; else showImei" class="m-t-sm">
        {{ aemContent?.device }}:
        <span *ngIf="line?.selectedDevice?.familyName">{{ line.selectedDevice.familyName }}</span>
        <span *ngIf="line?.byodCMMOrImei?.isSkipSelected">{{
          aemContent?.compatibilityCheckSkipped
        }}</span>
        <span
          *ngIf="
            !line?.selectedDevice?.familyName &&
            !line?.byodCMMOrImei &&
            !line?.byodSimData?.simNumber
          "
          >{{ aemContent?.noDeviceSelected }}</span
        >
      </p>
      <ng-template #showImei>
        <p class="m-t-sm">
          {{ aemContent?.imeiLabel }}
          <span>{{ line?.byodCMMOrImei?.imei }}</span>
        </p>
      </ng-template>
      <p
        class="m-t-sm"
        *ngIf="
          line?.byodSimData?.simDescription && !line?.byodSimData?.simNumber;
          else displaySimNumber
        "
      >
        {{ aemContent?.SIM }}: {{ line?.byodSimData?.simDescription }}
      </p>
      <ng-template #displaySimNumber>
        <p *ngIf="line?.byodSimData?.simNumber" class="m-t-sm">
          {{ aemContent?.SIM }}: {{ line?.byodSimData?.simNumber }}
        </p>
      </ng-template>
      <p class="m-t-sm">
        {{ aemContent?.plan }}:
        <span *ngIf="line?.plansFromCart?.planOfferName">{{
          line?.plansFromCart?.planOfferName
        }}</span>
        <span *ngIf="!line?.plansFromCart?.planOfferName">{{ aemContent?.noPlanSelected }}</span>
      </p>
    </div>
  </div>
  <p class="m-t-md" *ngIf="lineSummaryModels?.length > 0">
    <a href="javascript:void(0);" *ngIf="!seeAll" (click)="seeAll = !seeAll" id="cta-default-699">{{
      aemContent?.seeAllLineDetails
    }}</a>
    <a href="javascript:void(0);" *ngIf="seeAll" (click)="seeAll = !seeAll" id="cta-default-700">{{
      aemContent?.seeLess
    }}</a>
  </p>
  <tmo-product-summary
    [aemContent]="aemContent"
    [type]="'accessories'"
    [nonLineItems]="accessories"
    *ngIf="false"
  ></tmo-product-summary>
  <tmo-product-summary
    [aemContent]="aemContent"
    [type]="'devices'"
    [nonLineItems]="nonLineSummaryModels"
  ></tmo-product-summary>
</ng-container>
